import React, { useState, useEffect } from "react";
import "./custom.slider.css";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function CustomCarousel({ children }) {
  
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  let timerId;

  useEffect(() => {
    if (isAutoPlay) {
      timerId = setTimeout(() => {
        slideNext();
      }, 7000);
    }

    // Clear timeout on component unmount or when autoplay stops
    return () => clearTimeout(timerId);
  }, [activeIndex, isAutoPlay]);

  const slideNext = () => {
    setActiveIndex((val) => (val >= children.length - 1 ? 0 : val + 1));
  };

  const slidePrev = () => {
    setActiveIndex((val) => (val <= 0 ? children.length - 1 : val - 1));
  };

  const AutoPlayStop = () => {
    setIsAutoPlay(false);
  };

  const AutoPlayStart = () => {
    setIsAutoPlay(true);
  };

  return (
    <div
      className="container__slider"
      // onMouseEnter={AutoPlayStop}
      // onMouseLeave={AutoPlayStart}
    >
      {children.map((item, index) => (
        <div
          className={`slider__item slider__item-active-${activeIndex + 1}`}
          key={index}
        >
          {item}
        </div>
      ))}

      <div className="container__slider__links">
        {children.map((_, index) => (
          <button
            key={index}
            className={
              activeIndex === index
                ? "container__slider__links-small container__slider__links-small-active"
                : "container__slider__links-small"
            }
            onClick={(e) => {
              e.preventDefault();
              setActiveIndex(index);
            }}
          ></button>
        ))}
      </div>

      <button
        className="slider__btn-next slider__btn"
        onClick={(e) => {
          e.preventDefault();
          slideNext();
        }}
      >
       <ArrowForwardIosIcon style={{color:"#08449c", fontSize:"1.2rem"}}/>
      </button>
      <button
        className="slider__btn-prev slider__btn"
        onClick={(e) => {
          e.preventDefault();
          slidePrev();
        }}
      >
        <ArrowBackIosIcon style={{color:"#08449c", fontSize:"1.2rem"}}/>
      </button>
    </div>
  );
}

export default CustomCarousel;
